import React from 'react'
import css from './style.css'

const WelcomeImages = props => {
  return (
    <div className={css.container}>
      <div className={css.clip} />
      <img className={css.patternLeft}
        src={require('./images/welcome-diamond-pattern-left.png')}
        srcSet={[
          require('./images/welcome-diamond-pattern-left.png') + ' 1x',
          require('./images/welcome-diamond-pattern-left@2x.png') + ' 2x'
        ].join(', ')}
      />
      <img className={css.patternRight}
        src={require('./images/welcome-diamond-pattern-right.png')}
        srcSet={[
          require('./images/welcome-diamond-pattern-right.png') + ' 1x',
          require('./images/welcome-diamond-pattern-right@2x.png') + ' 2x'
        ].join(', ')}
      />
      <img
        className={[css.img, css.diamond].join(' ')}
        src={require('./images/welcome-diamond.png')}
        srcSet={[
          require('./images/welcome-diamond.png') + ' 1x',
          require('./images/welcome-diamond@2x.png') + ' 2x'
        ].join(', ')}
      />
    </div>
  )
}

export default WelcomeImages



// WEBPACK FOOTER //
// ./src/components/welcome-images/index.js